import { useCallback, useEffect, useState } from 'react';
/**
 * Observe keyboard interactions for a specific key.
 * @param {string} targetKey The keyboard key to observe, this comes from the KeyboardEvent.key value
 * @param {Object} options additional configuration object
 * @param {requestCallback} options.onDown fired when the key is pressed down
 * @param {requestCallback} options.onUp fired when the key is released up
 * @returns isPressed a boolean for currently pressed state
 * @example
 * import { useKeyEvent } from '@adsk/alloy-react-helpers';
 *
 * const { isPressed } = useKeyEvent('Escape', {
 *   onKeyDown: console.log,
 *   onKeyUp: console.log
 * });
 */
export default function useKeyEvent(targetKey) {
  let {
    onKeyDown,
    onKeyUp
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const [isPressed, setIsPressed] = useState(false);
  const downHandler = useCallback(e => {
    if (e.key === targetKey) {
      setIsPressed(true);
      onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
    }
  }, [targetKey, onKeyDown]);
  const upHandler = useCallback(e => {
    if (e.key === targetKey) {
      setIsPressed(false);
      onKeyUp === null || onKeyUp === void 0 ? void 0 : onKeyUp(e);
    }
  }, [targetKey, onKeyUp]);
  useEffect(() => {
    document.addEventListener('keydown', downHandler, false);
    document.addEventListener('keyup', upHandler, false);
    return () => {
      document.removeEventListener('keydown', downHandler, false);
      document.removeEventListener('keyup', upHandler, false);
    };
  }, [downHandler, upHandler]);
  return {
    isPressed
  };
}
//# sourceMappingURL=useKeyEvent.js.map